import { render, staticRenderFns } from "./DashModal.vue?vue&type=template&id=6245ff33&scoped=true&"
import script from "./DashModal.vue?vue&type=script&lang=js&"
export * from "./DashModal.vue?vue&type=script&lang=js&"
import style0 from "./DashModal.vue?vue&type=style&index=0&id=6245ff33&scoped=true&lang=scss&"
import style1 from "./DashModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245ff33",
  null
  
)

export default component.exports